import React from 'react'
import { useSelector } from 'react-redux'
import Chat from '../Chat/index'

const RightSidebar = () => {
  const showChat = useSelector((state) => state.gameSetting.showChat)

  return (
    <div className={`${showChat ? 'showChat chat-sidebar chat-collapse' : 'chat-sidebar chat-collapse'}`}>
      <div className='chat-content'>
        <Chat />
      </div>
    </div>
  )
}

export default React.memo(RightSidebar)
